<template>
  <v-card style="font-size: 12px !important;">
    <span class="row-label-wrapper">WO {{selectedTask.workOrder.workOrderNumber}} - {{selectedTask.taskNumber}} | {{selectedTask.region.name}}</span>
    <v-btn x-small text color="accent" :to="{name: 'TaskManager'}" style="float: right;">
      Back
    </v-btn>
    <v-divider></v-divider>
    <div v-for="checklistItem in selectedChecklist.checklistObject" :key="checklistItem.label">
      <v-row>
        <v-col>
          <td class="row-label-wrapper" v-if="checklistItem.required == true"><span style="color:red;">* </span>{{checklistItem.label}}</td>
          <td class="row-label-wrapper" v-else>{{checklistItem.label}}</td>
        </v-col>
        <v-col >
          <td><v-checkbox dense :disabled="isDisabled" hide-details success id="yesValue" v-model="checklistItem.yesChecked" label="Complete"></v-checkbox></td>
          <td><v-checkbox  dense :disabled="isDisabled" hide-details error id="noValue" v-model="checklistItem.noChecked" label="Required"></v-checkbox></td>
          <td><v-checkbox dense :disabled="isDisabled" hide-details color="primary" id="progressValue" v-model="checklistItem.progressChecked" label="In Progress"></v-checkbox></td>
          <td><v-checkbox dense :disabled="isDisabled" hide-details id="naValue" v-model="checklistItem.naChecked" label="N/A"></v-checkbox></td>
        </v-col>
        <v-col cols="2">  {{checklistItem.info}}</v-col>
        <v-col cols="1">{{checklistItem.checkedBy}} </v-col>
      </v-row>
      <div v-if="checklistItem.notes.length > 0">
        <v-row>
          <v-col>
            {{checklistItem.notes}}
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
    </div>
  </v-card>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'checklist-printable',

    data: () => ({
      isDisabled: true
    }),

    computed: {
      ...mapGetters({
        selectedChecklist: 'checklist/selectedChecklist',
        selectedTask: 'workOrderTask/selectedTask',
      }),


    }
  }
</script>
<style scoped>
    .row-label-wrapper {
    font-size: 12px;
    font-weight: 500;
    padding-right: 10px !important;
  }
  .col {

    padding-top: 0px !important;
    padding-bottom: 0px !important;
    margin-bottom: 0px !important;
    margin-top: 0px !important
  }

    .row {

    padding-top: 0px !important;
    padding-bottom: 0px !important;
    margin-bottom: 0px !important;
    margin-top: 0px !important
  }
  .v-input {
    padding-top: 0px !important;
    margin-top: 0px !important;
  }
</style>
